/* BARE MINIMUM — Product gallery video: real thumbnails, autoplay on select, original aspect ratio.
   Applies to every product that has a video in its media gallery. */
(function () {
  'use strict';
  var AUTO_THUMB = /thumbnail\.0{6,}/; /* Shopify's auto first-frame preview (often a blank frame) */
  var FRAME_AT = 1.5;                  /* seconds into the video used for the thumbnail frame */

  function srcOf(video) {
    var s = video.querySelector('source[type="video/mp4"]') || video.querySelector('source');
    return (s && s.src) || video.currentSrc || video.src || '';
  }

  function setupThumb(thumb, video) {
    if (thumb.dataset.bmVideoThumb) return;
    thumb.dataset.bmVideoThumb = '1';
    thumb.classList.add('bm-thumb--video');
    var img = thumb.querySelector('img');
    var useFrame = !img || AUTO_THUMB.test(img.getAttribute('src') || '');
    var src = srcOf(video).split('#')[0];
    if (useFrame && src) {
      var tv = document.createElement('video');
      tv.className = 'bm-thumb-video';
      tv.muted = true; tv.defaultMuted = true;
      tv.setAttribute('muted', ''); tv.setAttribute('playsinline', ''); tv.setAttribute('aria-hidden', 'true');
      tv.preload = 'metadata';
      tv.src = src + '#t=' + FRAME_AT;
      if (img) img.replaceWith(tv); else thumb.prepend(tv);
    }
    if (!thumb.querySelector('.bm-thumb-play')) {
      thumb.insertAdjacentHTML('beforeend', '<span class="bm-thumb-play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l11-6.5z"/></svg></span>');
    }
    thumb.setAttribute('aria-label', 'Play product video');
  }

  function setupSlide(video) {
    if (video.dataset.bmReady) return;
    video.dataset.bmReady = '1';
    video.parentElement.classList.add('bm-video-wrap');
    video.classList.add('bm-video');
    video.muted = true; video.defaultMuted = true;
    video.setAttribute('muted', ''); video.setAttribute('playsinline', '');
    video.loop = true; video.controls = true;
    /* Drop the blank auto poster so a real frame shows instead */
    var poster = video.getAttribute('poster') || '';
    if (AUTO_THUMB.test(poster)) {
      video.removeAttribute('poster');
      var s = video.querySelector('source');
      var src = srcOf(video);
      if (s && src.indexOf('#t=') === -1) { s.setAttribute('src', src + '#t=' + FRAME_AT); video.preload = 'metadata'; video.load(); }
    }
  }

  function isActive(slide) {
    return !slide.classList.contains('sp-visually-hidden') && !slide.classList.contains('sp-filter-hidden');
  }

  function playVideo(v) {
    if (!v) return;
    if (v.preload !== 'auto') v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* "On screen" = at least half of what can fit in the viewport is visible, horizontally and vertically.
     (Tall portrait videos can never be 50% visible on a short screen, so measure against the viewport.) */
  function onScreen(en) {
    if (!en.isIntersecting) return false;
    var b = en.boundingClientRect, r = en.intersectionRect;
    var needH = Math.min(b.height, window.innerHeight) * 0.5;
    var needW = Math.min(b.width, window.innerWidth) * 0.5;
    return r.height >= needH && r.width >= needW;
  }

  function init(root) {
    var gallery = (root || document).querySelector('.sp-gallery');
    if (!gallery || gallery.dataset.bmVideoInit) return;
    var videos = gallery.querySelectorAll('.sp-gallery__slide video');
    if (!videos.length) return;
    gallery.dataset.bmVideoInit = '1';

    videos.forEach(function (v) {
      var slide = v.closest('.sp-gallery__slide');
      setupSlide(v);
      var thumb = slide && gallery.querySelector('.sp-gallery__thumbnail[data-media-id="' + slide.dataset.mediaId + '"]');
      if (thumb) {
        setupThumb(thumb, v);
        /* Selecting the video thumbnail always starts playback */
        thumb.addEventListener('click', function () { setTimeout(function () { playVideo(v); }, 250); });
      }
    });

    /* Play when the video slide is on screen (thumbnail switch or mobile swipe); pause when it leaves */
    if ('IntersectionObserver' in window) {
      var steps = []; for (var i = 0; i <= 20; i++) steps.push(i / 20);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          var slide = v.closest('.sp-gallery__slide');
          if (onScreen(en) && (!slide || isActive(slide))) playVideo(v);
          else if (!en.isIntersecting || en.intersectionRect.width < en.boundingClientRect.width * 0.5) { if (!v.paused) v.pause(); }
        });
      }, { threshold: steps });
      videos.forEach(function (v) { io.observe(v); });
    }

    /* Keep in sync with the gallery's selected thumbnail */
    var last = null;
    new MutationObserver(function () {
      var sel = gallery.querySelector('.sp-gallery__thumbnail.is-selected');
      var id = sel && sel.dataset.mediaId;
      if (id === last) return;
      last = id;
      videos.forEach(function (v) {
        var slide = v.closest('.sp-gallery__slide');
        if (slide && slide.dataset.mediaId === id) playVideo(v); else if (!v.paused) v.pause();
      });
    }).observe(gallery, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  function start() { init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
